import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource} from '@angular/material/table';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { environment } from '../../../../environments/environment';
import { VideoPlayerDialogComponent } from '../video-player-dialog/video-player-dialog.component';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'app-search-results',
    templateUrl: './search-results.component.html',
    styleUrls: ['./search-results.component.scss']
})
export class SearchResultsComponent implements OnInit {
    public searchText = '';
    public searchResultDetails = [];
    public showFirstLastButtons = true;
    public searchDataSource = new MatTableDataSource([]);
    public displayedColumns: string[] = [];
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

    length = 100;
    pageSize = 5;
    pageSizeOptions: number[] = [5, 10, 25, 100];
    pageEvent: PageEvent;
    constructor(private cdr: ChangeDetectorRef, private commonService: TCCPCommonService, public dialog: MatDialog) { }

    ngOnInit() {
        this.displayedColumns = ['searchResult'];
        this.commonService.searchResultEmitter.subscribe(searchText => {
            this.getSearchResults(searchText);
        });
    }

    public getSearchResults(searchText: string) {
        this.searchDataSource.data = [];
        this.commonService.getSearchResults(searchText).subscribe(response => {
            this.searchText = searchText;
            if (response && response.length > 0) {
                const searchArray = [];
                response.forEach(element => {
                    if (element._source.contentDivision === environment.applicationName) {
                        searchArray.push(element);
                    }
                });
                this.searchDataSource.data = searchArray;

                setTimeout(() => {
                    this.searchDataSource.paginator = this.paginator;
                    this.cdr.detectChanges();
                });
            } else {
                this.searchResultDetails = [];
                this.searchDataSource.data = [];

            }
        });
    }

    public openFileInNewTab(e, url, type) {
        if (e) {
            e.preventDefault();
        }
        if (type === 'video') {
            const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            const match = url.match(regExp);
            const videoId = (match && match[7].length === 11) ? match[7] : false ;
            const videoName = url;
            this.dialog.open(VideoPlayerDialogComponent, { data: { videoUrl: videoId, name: videoName }, panelClass: 'icon-outside' });
        } else {
            if (url) {
                window.open(`${environment.baseURL}/${url}`, '_blank');
            }
        }
    }

    openDialog(url: string) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url.match(regExp);
        const videoId = (match && match[7].length === 11) ? match[7] : false ;
        const videoName = url;
        this.dialog.open(VideoPlayerDialogComponent, { data: { videoUrl: videoId, name: videoName }, panelClass: 'icon-outside' });
    }

}
